<script setup lang="ts">
import _ from 'lodash'
import { ref } from 'vue'
import type { NewHouseFooterVO } from '~/server/newhouse/interface'

const props = defineProps({
  tdkData: {
    type: Object as () => NewHouseFooterVO,
    default: () => ({}),
  },
  show: {
    type: Boolean,
    default: true,
  },
})

// 页面描述
const additionalDescription = computed(() => {
  return props.tdkData?.additionalDescription ?? ''
})

// 友情链接
const friendLinkTabList = computed(() => {
  const list = props.tdkData?.friendLinkTabList ?? []
  const resList = list.map((i: any) => {
    i.fList = _.chunk(i?.friendLinkList ?? [], 9) || []
    return i
  })
  return resList
})

// 面包屑
const breadCrumbsList = computed(() => {
  return props.tdkData?.breadCrumbsList ?? []
})

const active = ref<number>(0)
const swipeRefs = ref([])

// 定义多个ref
function setSwipeRef(el, index) {
  if (el) {
    swipeRefs.value[index] = el
  }
}
watch(active, (index) => {
  swipeRefs.value[index].resize()
})
</script>

<template>
  <div v-show="show" class="footer">
    <div class="footer-container">
      <!-- 友情链接 -->
      <div class="around-city">
        <div class="around-city-tab">
          <div v-for="(item, index) in friendLinkTabList" :key="index" :class="`around-city-tab-li ${active === index ? 'active' : ''}`" @click="() => (active = index)">
            {{ item.tabName }}
          </div>
        </div>
        <div v-for="(item, index) in friendLinkTabList" v-show="active === index" :key="`list-${index}`">
          <van-swipe :key="`friendLinkTabList${index}`" :ref="el => setSwipeRef(el, index)" indicator-color="#1da838" style="padding-bottom: 20px;">
            <van-swipe-item v-for="(i, idx) in item.fList" :key="`item-${index}-${idx}`" class="around-city-content">
              <div v-for="j in i" :key="`j-${index}-${idx}`" class="around-city-content-item">
                <a class="around-city-content-item-text" :href="j.mobileVersionUrl" target="_blank">
                  {{ j.floor }}
                </a>
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
      <!-- 面包屑 -->
      <div class="footer-bread">
        <div class="footer-bread-item">
          <span v-for="(item, index) in breadCrumbsList" :key="index">
            <template v-if="item.mobileVersionUrl">
              <a :href="item.mobileVersionUrl">{{ item.breadCrumbsName }}</a>
              <i> > </i>
            </template>
            <template v-else>
              <strong>{{ item.breadCrumbsName }}</strong>
            </template>
          </span>
        </div>
      </div>
      <!-- 页面描述 -->
      <div v-if="additionalDescription" class="footer-text1">
        <txt-ell :txt="additionalDescription" />
      </div>
    </div>

    <div class="footer-text2">
      <!-- <txt-ell txt="免责声明：本网站所发布的所有信息、资料、图表等仅供参考使用，不声明或保证其内容之正确性或可靠性；网站内所有内容亦不表明本网站之观点或意见，仅供参考和借鉴。购房者依据本网站提供的信息、资料及图表进行房屋交易等造成的任何后果与本网站无关；本页面所提到房屋面积如无特别标示，均指建筑面积。本网站资源部分来源于网友上传分享或公开网络，相应权利归原作者所有；如果您认为本网站的任何内容侵犯您的合法权利，请您通过以下联系方式告知我们并提供相关证据及说明，本网站会尽快采取相应措施。联系方式：邮箱：2299470@qq.com，电话：0573-83671655。" /> -->
      免责声明：本网站所发布的所有信息、资料、图表等仅供参考使用，不声明或保证其内容之正确性或可靠性；网站内所有内容亦不表明本网站之观点或意见，仅供参考和借鉴。购房者依据本网站提供的信息、资料及图表进行房屋交易等造成的任何后果与本网站无关；本页面所提到房屋面积如无特别标示，均指建筑面积。本网站资源部分来源于网友上传分享或公开网络，相应权利归原作者所有；如果您认为本网站的任何内容侵犯您的合法权利，请您通过以下联系方式告知我们并提供相关证据及说明，本网站会尽快采取相应措施。联系方式：邮箱：2299470@qq.com，电话：0573-83671655。
    </div>
  </div>
</template>

<style scoped lang="scss">
@mixin splid(){
  position: relative;
  &:before{
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 10px;
    background-color: #eee;
    content:'';
  }
}

.footer-container {
  padding: 20px 20px 0;
  background: #fff;
  // width: calc(100% - 40px);
  margin: 0 auto;
  border-radius: 20px;
}

.footer {
  background: #F5F5F5;
  margin-top: 10px;
  // padding: 20px 25px 150px;
  padding: 0 25px 150px;
  font-size: 28px;
  // width: calc(100% - 20px);
  margin: 0 auto;
  // @include splid();
  .footer-bread-item{
    height: 50px;
    line-height: 50px;
    padding: 10px 20px 0;
    @include ell();
    // border-bottom: 1PX solid #eee;
    span{
      color: #919191;
      line-height: 1.8;
    }
    strong{
      font-weight: normal;
    }
  }
  &-text1 {
    color: #919191;
    line-height: 1.8;
    padding: 0;
    @include ellnum(2);
    margin-bottom: 20px;
  }
  &-text2 {
    color: #919191;
    line-height: 1.8;
    padding: 0 20px;
    // @include ellnum(2);
    margin-bottom: 20px;
  }
  .around-city {
    padding: 20px;
    padding-bottom: 0;
    border-bottom: 1PX solid #eee;
    // @include splid();
    &-tab {
      display: flex;
      overflow-x: auto;
      &-li {
        color: #919191;
        line-height: 1.8;
        padding: 0 20px 20px;
        cursor: pointer;
        position: relative;
        white-space: nowrap;
        font-size: 31px;
        font-weight: bold;
        &.active {
          color: #000;
          &:after {
            position: absolute;
            display: block;
            content: '';
            left: 0;
            right: 0;
            bottom: 0;
            height: 8px;
            background-color: #1da838;
          }
        }
      }
    }
    &-content {
      display: flex;
      flex-wrap: wrap;
      padding-top: 30px;
      &-item {
        width: 33.3333%;
        font-size: 24px;
        margin-bottom: 20px;
        &-text {
          @include ell();
          border: 1PX solid #C4C4C4;
          display: block;
          // color: #919191;
          color: #3D3D3D;
          height: 50px;
          line-height: 50px;
          padding: 0 15px;
          margin-right: 15px;
          text-align: center;
        }
        &:nth-child(3n) {
          .around-city-content-item-text{
            margin-right: 0;
          }
        }
      }
    }
  }
  &-text2{
    // padding-top: 30px;
    // @include splid();
  }
}
</style>
